// export const black = [
//   {
//     id: 1,
//     img: "https://i.ibb.co/VDnT7z3/Screenshot-20230115-143749-Amazon.jpg",
//     link: "https://www.amazon.in/Sweven-Blueberry-Gently-Rolled-Aromatic/dp/B0BR9YTGQ2/ref=sr_1_9?crid=KYXJG10QMXBB&keywords=sweven+black+tea&qid=1673953193&sprefix=sweven+black+te%2Caps%2C384&sr=8-9",
//   // tests:"Blue Berry",
//   tests:"Click On Me",
//   },
//   {
//     id: 2,
//     img: "https://i.ibb.co/7tfQzW4/Screenshot-20230115-143812-Amazon.jpg",
//     link: "https://www.amazon.in/Sweven-Cinnamon-Gently-Rolled-Aromatic/dp/B0BR7SMRV1/ref=sr_1_11?crid=KYXJG10QMXBB&keywords=sweven+black+tea&qid=1673953193&sprefix=sweven+black+te%2Caps%2C384&sr=8-11",
//     // tests:"Cinnamon Twist",
//     tests:"Click On Me",
//   },
//   {
//     id: 3,
//     img: "https://i.ibb.co/nQJ93fZ/Screenshot-20230115-143838-Amazon.jpg",
//     link: "https://www.amazon.in/Sweven-Bergamot-Gently-Rolled-Aromatic/dp/B0BRCL6DY3/ref=sr_1_10?crid=KYXJG10QMXBB&keywords=sweven+black+tea&qid=1673953193&sprefix=sweven+black+te%2Caps%2C384&sr=8-10",
//     // tests:"Earl Gray & Bergamot Peels",
//     tests:"Click On Me",
//   },
//   {
//     id: 4,
//     img: "https://i.ibb.co/vdtcDSx/Screenshot-20230115-143631-Amazon.jpg",
//     link: "https://www.amazon.in/Sweven-Passion-Gently-Rolled-Aromatic/dp/B0BRCL2H2L/ref=sr_1_5?crid=KYXJG10QMXBB&keywords=sweven+black+tea&qid=1673953193&sprefix=sweven+black+te%2Caps%2C384&sr=8-5",
//     // tests:"Passion Fruit",
//     tests:"Click On Me",
//   },
//   {
//     id: 5,
//     img: "https://i.ibb.co/V9ZgQvy/Screenshot-20230115-143719-Amazon.jpg",
//     link: "https://www.amazon.in/Sweven-Lovely-Vanilla-Gently-Aromatic/dp/B0BRCK8KV5/ref=sr_1_8?crid=KYXJG10QMXBB&keywords=sweven+black+tea&qid=1673953193&sprefix=sweven+black+te%2Caps%2C384&sr=8-8",
//     // tests:"Lovely Vanilla Punch",
//     tests:"Click On Me",
//   },
//   {
//     id: 6,
//     img: "https://i.ibb.co/VwkvNSQ/Screenshot-20230115-143654-Amazon.jpg",
//     link: "https://www.amazon.in/Sweven-Delicious-Healthy-Ingredients-Aromatic/dp/B0BR9ZCXLG/ref=sr_1_6?crid=KYXJG10QMXBB&keywords=sweven+black+tea&qid=1673953193&sprefix=sweven+black+te%2Caps%2C384&sr=8-6",
//     // tests:"Wine Smoke",
//     tests:"Click On Me",
//   },
// ];
export const ice = [
  {
    id: 1,
    img: "https://i.ibb.co/G3tMdfd/Whats-App-Image-2023-05-12-at-5-33-47-PM-1.jpg",
    // link: "https://www.amazon.in/Sweven-Refreshing-Strawberry-Ingredients-Flavourful/dp/B0BQZZWYX7/ref=sr_1_35?crid=322GTN1CLH33W&keywords=sweven+green+tea&qid=1673953451&sprefix=sweven+green+tea%2Caps%2C340&sr=8-35",
    // tests:"StrawBerry Ice Tea",
    tests:"Click On Me",
  },
  {
    id: 2,
    img: "https://i.ibb.co/cQKh5Pk/Whats-App-Image-2023-05-12-at-5-33-47-PM.jpg",
    // link: "https://www.amazon.in/Sweven-Kashmiri-100grams-Blended-Ingredients/dp/B0BR13CDBG/ref=sr_1_43?crid=322GTN1CLH33W&keywords=sweven+green+tea&qid=1673953451&sprefix=sweven+green+tea%2Caps%2C340&sr=8-43",
    tests:"Click On Me",
    // tests:"Kashmiri Kahwa Chai",
  },
  {
    id: 3,
    img: "https://i.ibb.co/QFXFDcz/Whats-App-Image-2023-05-12-at-5-33-46-PM-2.jpg",
    // link: "https://www.amazon.in/Sweven-Refreshing-Natural-Ingredients-Flavourful/dp/B0BR12KHX9/ref=sr_1_34?crid=322GTN1CLH33W&keywords=sweven+green+tea&qid=1673953451&sprefix=sweven+green+tea%2Caps%2C340&sr=8-34",
    tests:"Click On Me",
    // tests:"Mango Ice Tea",
  },
  {
    id: 4,
    img: "https://i.ibb.co/0KS50BK/Whats-App-Image-2023-05-12-at-5-33-46-PM-1.jpg",
    // link: "https://www.amazon.in/Sweven-100grams-caradamom-Coriander-Ingredients/dp/B0BR18JWKV/ref=sr_1_7?crid=KYXJG10QMXBB&keywords=sweven+black+tea&qid=1673953193&sprefix=sweven+black+te%2Caps%2C384&sr=8-7",
    tests:"Click On Me",
    // tests:"Herbal Tulsi Tea",
  },
  {
    id: 5,
    img: "https://i.ibb.co/X7W3dxg/Whats-App-Image-2023-05-12-at-5-33-45-PM-2.jpg",
    // link: "https://www.amazon.in/Sweven-Refreshing-Natural-Ingredients-Flavourful/dp/B0BR13SLZP/ref=sr_1_33?crid=322GTN1CLH33W&keywords=sweven+green+tea&qid=1673953451&sprefix=sweven+green+tea%2Caps%2C340&sr=8-33",
    // tests:"Cool Mint Tea",
    tests:"Click On Me",
  },
  {
    id: 6,
    img: "https://i.ibb.co/sVBz0rg/Whats-App-Image-2023-05-12-at-5-33-48-PM-1.jpg",
    // link: "https://www.amazon.in/Sweven-Premium-Strong-Organic-Natural/dp/B0BR12HQ8K/ref=sr_1_5?crid=V37M8OARWLBT&keywords=sweven+premium+chai&qid=1673954216&sprefix=sweven+premium+chai%2Caps%2C427&sr=8-5",
    // tests:"Sweven Premium Chai",
    tests:"Click On Me",
  },
];
export const green = [
  {
    id: 1,
    img: "https://i.ibb.co/M7gVRq9/Whats-App-Image-2023-05-12-at-5-33-48-PM.jpg",
    // link: "https://www.amazon.in/Sweven-Natural-Flavour-Refreshing-Herbal/dp/B0BR7P2142/ref=sr_1_10?crid=322GTN1CLH33W&keywords=sweven+green+tea&qid=1673953451&sprefix=sweven+green+tea%2Caps%2C340&sr=8-10",
    tests:"Click On Me",
    // tests:"Tulsi",
    // name:"nipun yadav"
  },
  {
    id: 2,
    img: "https://i.ibb.co/gSd0SPV/Whats-App-Image-2023-05-12-at-5-33-46-PM.jpg",
    // link: "https://www.amazon.in/Sweven-Natural-Flavour-Refreshing-Infusion/dp/B0BR5MTB65/ref=sr_1_9?crid=322GTN1CLH33W&keywords=sweven+green+tea&qid=1673953451&sprefix=sweven+green+tea%2Caps%2C340&sr=8-9",
    // tests:"Sencha & Lemon Grass",
    tests:"Click On Me",
  },
  {
    id: 3,
    img: "https://i.ibb.co/wJZBv4D/Whats-App-Image-2023-05-12-at-5-33-45-PM-1.jpg",
    // link: "https://www.amazon.in/Sweven-Natural-Flavour-Refreshing-Infusion/dp/B0BR7QPW96/ref=sr_1_12?crid=322GTN1CLH33W&keywords=sweven+green+tea&qid=1673953451&sprefix=sweven+green+tea%2Caps%2C340&sr=8-12",
    // tests:"Rose",
    tests:"Click On Me",
  },
  {
    id: 4,
    img: "https://i.ibb.co/xLx0w0W/Whats-App-Image-2023-05-12-at-5-33-45-PM.jpg",
    // link: "https://www.amazon.in/Sweven-Cranberry-Natural-Refreshing-Infusion/dp/B0BR5PCN76/ref=sr_1_8?crid=322GTN1CLH33W&keywords=sweven+green+tea&qid=1673953451&sprefix=sweven+green+tea%2Caps%2C340&sr=8-8",
    // tests:"Purple CranBerry",
    tests:"Click On Me",
  },
  {
    id: 5,
    img: "https://i.ibb.co/ypS2S2Y/1ffd2ffe-6688-4fc6-a01d-9bc8228e9aa5.jpg",
    // link: "https://www.amazon.in/Sweven-Minthos-Natural-Flavour-Refreshing/dp/B0BR5P1LP7/ref=sr_1_13?crid=322GTN1CLH33W&keywords=sweven+green+tea&qid=1673953451&sprefix=sweven+green+tea%2Caps%2C340&sr=8-13",
    // tests:"Minthos Green",
    tests:"Click On Me",
  },
  {
    id: 6,
    img: "https://i.ibb.co/KDVwT8C/Whats-App-Image-2023-05-12-at-5-33-44-PM-1.jpg",
    // link: "https://www.amazon.in/Sweven-Natural-Flavour-Refreshing-Herbal/dp/B0BR7QYJFH/ref=sr_1_6?crid=322GTN1CLH33W&keywords=sweven+green+tea&qid=1673953451&sprefix=sweven+green+tea%2Caps%2C340&sr=8-6",
    // tests:"Lemon",
    tests:"Click On Me",
  },
  {
    id: 7,
    img: "https://i.ibb.co/Bg6tP8h/Whats-App-Image-2023-05-12-at-5-33-44-PM.jpg",
    // link: "https://www.amazon.in/Sweven-Natural-Flavour-Refreshing-Herbal/dp/B0BR5NQ7R5/ref=sr_1_14?crid=322GTN1CLH33W&keywords=sweven+green+tea&qid=1673953451&sprefix=sweven+green+tea%2Caps%2C340&sr=8-14",
    // tests:"Lemon Grass",
    tests:"Click On Me",
  },
  {
    id: 8,
    img: "https://i.ibb.co/y4TQG7J/Whats-App-Image-2023-05-12-at-5-33-43-PM.jpg",
    // link: "https://www.amazon.in/Sweven-Lavender-Natural-Refreshing-Infusion/dp/B0BR5QB3HF/ref=sr_1_5?crid=322GTN1CLH33W&keywords=sweven+green+tea&qid=1673953451&sprefix=sweven+green+tea%2Caps%2C340&sr=8-5",
    // tests:"Lavender",
    tests:"Click On Me",
  },
  {
    id: 9,
    img: "https://i.ibb.co/GvGzTVf/Whats-App-Image-2023-05-12-at-5-33-41-PM-1.jpg",
    // link: "https://www.amazon.in/Sweven-Natural-Flavour-Refreshing-Herbal/dp/B0BR5R3RLW/ref=sr_1_11?crid=322GTN1CLH33W&keywords=sweven+green+tea&qid=1673953451&sprefix=sweven+green+tea%2Caps%2C340&sr=8-11",
    // tests:"Detox",
    tests:"Click On Me",
  },
  {
    id: 10,
    img: "https://i.ibb.co/3RxtvbC/Whats-App-Image-2023-05-12-at-5-33-41-PM.jpg",
    // link: "https://www.amazon.in/Sweven-Jasmine-Natural-Flavour-Refreshing/dp/B0BR5QT56G/ref=sr_1_12?m=A1QWS82MLTEUXH&marketplaceID=A21TJRUUN4KGV&qid=1673954504&s=merchant-items&sr=1-12",
  },
  {
    id: 11,
    img: "https://i.ibb.co/n3xP7tb/Whats-App-Image-2023-05-12-at-5-33-40-PM.jpg",
    // link: "https://www.amazon.in/Sweven-Jasmine-Natural-Flavour-Refreshing/dp/B0BR5QT56G/ref=sr_1_12?m=A1QWS82MLTEUXH&marketplaceID=A21TJRUUN4KGV&qid=1673954504&s=merchant-items&sr=1-12",
  },
  {
    id: 12,
    img: "https://i.ibb.co/QHHPk6s/9ymy8vsjjc951.jpg",
    // link: "https://www.amazon.in/Sweven-Jasmine-Natural-Flavour-Refreshing/dp/B0BR5QT56G/ref=sr_1_12?m=A1QWS82MLTEUXH&marketplaceID=A21TJRUUN4KGV&qid=1673954504&s=merchant-items&sr=1-12",
  },
];
